import { z } from 'zod';
import { MoneyStringSchema } from './common.js';

export const TransferirSchema = z.object({
  origemAccountId: z.string().uuid(),
  destinoAccountId: z.string().uuid(),
  valor: MoneyStringSchema,
  justificativa: z.string().min(1),
});
export type TransferirDTO = z.infer<typeof TransferirSchema>;

export const ResolveApprovalSchema = z.object({
  justificativa: z.string().optional(),
});
export type ResolveApprovalDTO = z.infer<typeof ResolveApprovalSchema>;

export const ApprovalViewSchema = z.object({
  id: z.string().uuid(),
  tipo: z.enum(['transferencia', 'viagem', 'desconto', 'estorno', 'ajuste']),
  status: z.enum(['pendente', 'aprovado', 'rejeitado']),
  referenciaId: z.string().uuid().nullable(),
});
export type ApprovalViewDTO = z.infer<typeof ApprovalViewSchema>;

export const LoanViewSchema = z.object({
  id: z.string().uuid(),
  caixaOrigemId: z.string().uuid(),
  caixaDestinoId: z.string().uuid(),
  valor: MoneyStringSchema,
  saldoDevedor: MoneyStringSchema,
  status: z.enum(['aberto', 'quitado']),
});
export type LoanViewDTO = z.infer<typeof LoanViewSchema>;
